import { useSeo } from "@/hooks/useSeo";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const TermsPage = () => {
  useSeo('Terms of Service | Luxe Lords', 'Terms of sale for Luxe Lords perfume atomizers, including delivery and returns.', '/terms');
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-20 px-6 lg:px-12">
        <article className="container mx-auto max-w-3xl">
          
          <h1 className="font-serif text-3xl md:text-4xl font-normal tracking-tight text-foreground mb-3">Terms of Service</h1>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-14">Last updated: 19 May 2026</p>

          <div className="space-y-8 text-body text-muted-foreground leading-relaxed">
            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">1. About these terms</h2>
              <p>
                These terms govern your use of luxelords.co.uk and any purchase you make from us.
                By using the site you agree to them.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">2. Orders &amp; pricing</h2>
              <p>
                All prices are in GBP and include VAT where applicable. Placing an order is an
                offer to buy; the contract is formed when we send a dispatch confirmation. We may
                refuse or cancel orders if a product is unavailable, mis-priced, or we suspect
                fraud.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">3. Delivery</h2>
              <p>
                UK standard delivery is free. Next day delivery is available for £2.95 and can be selected at checkout. Estimated delivery times are shown at checkout. Risk passes to you on delivery.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">4. Right to cancel (UK consumers)</h2>
              <p>
                Under the Consumer Contracts Regulations 2013 you may cancel your order within 14
                days of receiving it, for any reason. Return the goods unused and in their
                original packaging within a further 14 days. We will refund the price and standard
                delivery cost within 14 days of receiving the goods back. Return shipping is your
                responsibility unless the item is faulty.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">5. Faulty or incorrect items</h2>
              <p>
                Under the Consumer Rights Act 2015 goods must be of satisfactory quality, fit for
                purpose, and as described. Contact us at info@luxelords.com within 30 days if
                anything is wrong.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">6. Intellectual property</h2>
              <p>
                All content on this site (text, images, logos, the "Luxe Lords™" mark) belongs to
                Luxe Lords or its licensors. You may not reproduce it without written permission.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">7. Liability</h2>
              <p>
                Nothing in these terms limits liability for death, personal injury caused by our
                negligence, fraud, or any other liability that cannot be limited under English
                law. Subject to that, our total liability for any order is limited to the price
                paid for that order.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">8. Governing law</h2>
              <p>
                These terms are governed by the laws of England and Wales. Disputes are subject
                to the exclusive jurisdiction of the English courts. If you are a consumer
                resident elsewhere in the UK, you may also bring proceedings in your local
                courts.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl md:text-2xl font-normal tracking-tight text-foreground mb-3">9. Contact</h2>
              <p>
                Easy Box Ltd (trading as Luxe Lords) — 356 St. Ann's Road, London, England, N15 3ST — info@luxelords.com
              </p>
            </section>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
